import styled from '@emotion/styled';
import { IconButtonGhost, TooltipContainer } from '@kc-console/common-ui';
import { t } from '@kc-console/core';
import { IcChevronDownSmallRegular } from '@kep/kcds-icons';

export interface ExpandButtonProps {
  expanded: boolean;
  disabled?: boolean;
  /**
   * 버튼이 비활성(`disabled`)일 때 hover 시 노출할 툴팁 메시지입니다.
   * 비어 있으면 툴팁을 표시하지 않습니다.
   */
  message?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function ExpandButton(props: ExpandButtonProps) {
  const { expanded, disabled, message, onClick } = props;

  const button = (
    // 아이콘 전용 버튼이라 텍스트가 없으므로 aria-label로 접근 가능한 이름을 제공한다.
    // `aria-expanded`는 실제 확장을 제어하는 버튼 요소에만 유효한 속성이므로 아이콘(svg)이 아닌 버튼에 부여한다.
    <ExpandButtonRoot
      size="md"
      variant="primary"
      disabled={disabled}
      aria-expanded={expanded}
      aria-label={expanded ? t('ui:action.collapse') : t('ui:action.expand')}
      onClick={onClick}
    >
      <IcChevronDownSmallRegular />
    </ExpandButtonRoot>
  );

  // 비활성(disabled) 버튼은 pointer 이벤트를 발생시키지 않아 단순 Tooltip 래핑으로는 hover가 잡히지 않는다.
  // 사유 메시지가 있으면 TooltipContainer(span 래퍼)로 감싸 비활성 상태에서도 툴팁이 노출되도록 한다.
  if (disabled && message) {
    return (
      <TooltipContainer message={message} placement="top">
        {button}
      </TooltipContainer>
    );
  }

  return button;
}

const ExpandButtonRoot = styled(IconButtonGhost)`
  margin: -8px;

  /* 확장 상태 표시는 버튼의 aria-expanded를 훅으로 삼아 내부 아이콘만 회전시킨다. */
  &[aria-expanded='true'] svg {
    transform: rotate(180deg);
  }
`;
